import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const JenisProduk = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [jenisKomoditi, setJenisKomoditi] = useState('')

    useEffect(() => {
        const getJenisKomoditi = async () => {
            const response = await masterService.getJenisProdukById(id)
            setJenisKomoditi(response.data.jenisProduk)
        }
        getJenisKomoditi()
    }, [masterService, id])

    return (
        <>
            {jenisKomoditi}
        </>
    )
}

export default JenisProduk